export default __webpack_public_path__ + "static/media/circle-gray.c853da67.svg";